import { Element } from 'slate/dist/interfaces/element';
import { flattenDeep } from 'lodash';

export const findBellowByType = (element: Element, childType: string): Element[] => {
  if (element) {
    if (element.type === childType) {
      return [element];
    }

    if (element.children?.length > 0) {
      return flattenDeep(element.children.map(elm => findBellowByType(elm, childType)));
    }
  }

  return [];
};
